import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "encodableregistry"
    }}>{`@encodable/registry`}</h1>
    <p><a parentName="p" {...{
        "href": "https://img.shields.io/npm/v/@encodable/registry.svg?style=flat"
      }}><img alt="Version" src="https://img.shields.io/npm/v/@encodable/registry.svg?style=flat" /></a>{`
`}<a parentName="p" {...{
        "href": "https://david-dm.org/kristw/encodable?path=packages/encodable-registry"
      }}><img alt="David (path)" src="https://img.shields.io/david/kristw/encodable.svg?path=packages%2Fencodable-registry&style=flat-square" /></a></p>
    <p>{`All-purpose map data structure on steroids.`}</p>
    <ul>
      <li parentName="ul">{`Can be used to store state as global, making a true singleton that can be used across packages.`}</li>
      <li parentName="ul">{`Can be used locally as well.`}</li>
      <li parentName="ul">{`Support asynchronous values.`}</li>
    </ul>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install @encodable/registry global-box
`}</code></pre>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <p>{`Create registries`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { Registry, SyncRegistry, makeSingleton } from '@encodable/registry';

// local registry (when globalId is not defined)
const registry = new Registry<string>();

// global registry
const globalRegistry = new Registry({ globalId: 'my-global-key' });

// create a singleton factory function
const getSingleton = makeSingleton(() => new Registry({ globalId: 'my-global-key' }));

`}</code></pre>
    <p>{`Registering`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`// constant value
registry.registerValue('key', 1);
// sync loader
registry.registerLoader('key', () => 1);
// async loader
registry.registerLoader('key', () => Promise.resolve(1));
`}</code></pre>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Registry`}</inlineCode>{` can support both constant values and sync/async loaders.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`SyncRegistry`}</inlineCode>{` only support constant values and sync loaders.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      